import {
  Component,
  ChangeDetectionStrategy,
  input,
  InputSignal,
  model,
  ModelSignal,
  output,
  OutputEmitterRef,
  computed,
  Signal
} from '@angular/core';
import { PaginationComponent } from '../../../components/pagination/pagination.component';

@Component({
  selector: 'td-wb-learn-pagination',
  templateUrl: './learn-pagination.component.html',
  styleUrls: ['./learn-pagination.component.scss'],
  imports: [
    PaginationComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LearnPaginationComponent {
  totalCount: InputSignal<number> = input<number>();
  selectedPage: ModelSignal<number> = model<number>();
  contentsPerPage: InputSignal<number> = input<number>();
  selectedPageChange: OutputEmitterRef<number> = output<number>();
  showPagination: Signal<boolean> = computed((): boolean => this.totalCount() > this.contentsPerPage());

  onPageClick(page: number): void {
    this.selectedPage.set(page);
    this.selectedPageChange.emit(page);
  }
}
